import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApiKey } from '../../contexts/ApiKeyContext';
import { userLogout } from '../../services/UserService';

export const LogoutPage = () => {
  const navigate = useNavigate();
  const { apiKey, clearApiKey } = useApiKey();

  const handleGoHome = () => {
    navigate('/');
  };

  useEffect(() => {
    userLogout(apiKey);
    clearApiKey();
  }, []);

  return (
    <Container
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" style={{ marginBottom: 20 }}>
        Wylogowano
      </Typography>
      <Button onClick={handleGoHome} variant="contained" color="primary" size="large" style={{ marginTop: 20 }}>
        Wróć na stronę główną
      </Button>
    </Container>
  );
};
